
import spritesheet from '../icons/sprite-semaforo.png';

export default {
    sprite: {
        backgroundImage: `url(${ spritesheet })`,
        backgroundRepeat: 'no-repeat',
        display: 'inline-block',       
    }, 
    spriteSemaforoamarillo: {
        width: '21px',
        height: '11px',
        backgroundPosition: '-5px -5px',
    },
    
    spriteSemaforoblanco: {
        width: '21px',
        height: '11px',
        backgroundPosition: '-5px -26px',
    },
    
    spriteSemaforonaranjo: {
        width: '21px',
        height: '11px',
        backgroundPosition: '-36px -5px',
    },
    
    spriteSemafororojo: {
        width: '21px',
        height: '11px',
        backgroundPosition: '-36px -26px',
    },
    
    spriteSemaforoverde: {
        width: '21px',
        height: '11px',
        backgroundPosition: '-5px -47px',
    },

}